export const STATUS_CHIP_COMPLETED = "completed"
export const STATUS_CHIP_IN_PROGRESS = "inProgress"
export const STATUS_CHIP_QUEUED = "queued"
